export const removeEmptyAttributes = (obj: {
  [key: string]: string | number | undefined | null;
}) =>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
